export const metrics_api = `https://${process.env.REACT_APP_API}.execute-api.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_STAGE}/metrics`
export const entra_app_id = process.env.REACT_APP_ENTRA_APP_ID
export const entra_authority = process.env.REACT_APP_ENTRA_AUTHORITY

export function transformDynamoDBJSON(data) {
    function transformValue(value) {
        if (value === undefined || value === null) return null;
        if (typeof value !== 'object') return value;

        if ('S' in value) return value.S;
        if ('N' in value) return Number(value.N);
        if ('BOOL' in value) return value.BOOL;
        if ('NULL' in value) return null;
        if ('M' in value) return transformMap(value.M);
        if ('L' in value) return value.L.map(transformValue);
        if ('SS' in value) return value.SS;
        if ('NS' in value) return value.NS.map(Number);
        if ('BS' in value) return value.BS;

        return transformMap(value);
    }

    function transformMap(map) {
        const result = {};
        for (const key in map) {
            result[key] = transformValue(map[key]);
        }
        return result;
    }

    // Directly return the transformed Items array
    if (Array.isArray(data.Items)) {
        return data.Items.map(transformMap);
    } else if (Array.isArray(data)) {
        // If the input is already an array, transform it directly
        return data.map(transformMap);
    } else {
        // If it's neither an array nor has an Items property, return an empty array
        console.warn('Unexpected data structure in transformDynamoDBJSON');
        return [];
    }
}